/* eslint-disable @typescript-eslint/default-param-last */
import { IAppStatusAction } from "@/types/appStatus.types";

import {
  HIDE_TOAST,
  SET_USER_JOIN_LEAVE_NOTIFICATION,
  SET_WHITE_LABEL_ENABLED,
  SHOW_TOAST,
  SHOW_ERROR_PAGE,
  HIDE_ERROR_PAGE,
  MULTIPLE_TAB_DETECTED,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const appStatusReducer = (
  state = initialState.appStatus,
  action: IAppStatusAction,
) => {
  switch (action.type) {
    case SET_WHITE_LABEL_ENABLED:
      return {
        ...state,
        whitelabelingEnabled: action.payload.whitelabelingEnabled,
      };
    case SHOW_TOAST:
      return { ...state, toast: action.payload.toast };
    case HIDE_TOAST:
      return { ...state, toast: initialState.appStatus.toast };
    case SHOW_ERROR_PAGE:
      return { ...state, errorPage: action.payload.errorPage };
    case HIDE_ERROR_PAGE:
      return { ...state, errorPage: initialState.appStatus.errorPage };
    case MULTIPLE_TAB_DETECTED:
      return {
        ...state,
        multiTabDetected: action.payload.multipleTabDetected,
      };
    case SET_USER_JOIN_LEAVE_NOTIFICATION:
      return {
        ...state,
        userJoinLeaveNotification: action.payload.userJoinLeaveNotification,
      };
    default:
      return state;
  }
};

export default appStatusReducer;
